import script from "./Loader.vue?vue&type=script&setup=true&lang=js"
export * from "./Loader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"Loader.vue"]])

export default __exports__